import { sendEvent } from '../helpers/analytics';
import safeLocalStorage from '../helpers/safeLocalStorage';
import isLanguagePopupHidden, { LANGUAGE_POPUP_STORAGE_KEY } from './isLanguagePopupHidden';

const init = () => {
  const rootNode = document.getElementById('language-popup');
  if (!rootNode) return;

  if (isLanguagePopupHidden()) {
    rootNode.remove();
    return;
  }

  rootNode.classList.add('-visible');

  sendEvent(window.eventCategory, 'language_popup', 'show');

  const closeTriggers = rootNode.querySelectorAll('[data-language-popup-close]');

  const onTriggerClick = () => {
    safeLocalStorage.setItem(LANGUAGE_POPUP_STORAGE_KEY, true);
    Array.from(closeTriggers).forEach((trigger) =>
      trigger.removeEventListener('click', onTriggerClick),
    );
    rootNode.remove();
  };

  Array.from(closeTriggers).forEach((trigger) => {
    trigger.addEventListener('click', onTriggerClick);
  });
};

init();
